var scroll = {
    dir: 0,

    init: () => {
        let pos = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        let header = helper.element("header");
        let body = helper.element("body");

        if (header) {
            if (pos > 30) {
                header.classList.add("scroll");
            } else {
                header.classList.remove("scroll");
            }

            if (pos > scroll.dir && pos > 150 && !body.classList.contains("open")) {
                header.classList.add("hidden");
            } else {
                header.classList.remove("hidden");
            }
        }
        scroll.dir = pos;
    },

    // Smoothly brings an element into view, clear of the fixed header. Used for in-page
    // jumps: a "#id" link resolves against <base href="/"> and would leave the page.
    to: (id) => {
        let element = document.getElementById(id);
        if (!element)
            return;

        let top = element.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({top: top, behavior: 'smooth'});
    }
};